import _ from 'lodash';
import moment from 'moment';

export const isEmptyValue = (value) => {
  if (_.isNumber(value)) {
    return false;
  }
  if (_.isObject(value)) {
    return _.every(value, (v) => (isEmptyValue(v)));
  }
  return _.isEmpty(value);
};

export const Marshall = {
  apply: (filters, attr) => _.reduce(filters, (result, v, k) => {
    const applyFun = _.get(Marshall, _.compact(_.flatten([attr, k, 'apply'])));
    let marshalledValue = {};
    if (!isEmptyValue(v)) {
      marshalledValue = _.isFunction(applyFun) ? applyFun(v) : { [k]: v };
    }
    return _.merge(result, marshalledValue);
  }, {}),
  spot: {
    apply: (filters) => ({ spot: Marshall.apply(filters, 'spot') }),
    date_range: {
      apply: (filters) => ({
        start_date: filters[0].startOf('day'),
        end_date: filters[1].endOf('day'),
      }),
    },
    accepted_date_range: {
      apply: (filters) => ({
        accepted_start_date: filters[0].startOf('day'),
        accepted_end_date: filters[1].endOf('day'),
      }),
    },
    attributes: {
      apply: (filters) => ({ attributes: _.compact(filters) }),
    },
  },
  answers: {
    apply: (filters) => ({
      answers: Object.entries(_.groupBy(filters, 'urlId')).map((filterEntries) => {
        const newData = filterEntries[1].map((answerFilter) => (
          { name: answerFilter.name, value: answerFilter.value }
        ));
        return { url_id: filterEntries[0], data: newData };
      }),
    }),
  },
};

export const unmarshallAttributes = (filters) => (
  { attributes: (_.reduce(filters, (res, v, k) => (Object.assign(res, { [k]: v })), {})) }
);

const Unmarshall = {
  apply: (filters, attr) => {
    let decorateFun = _.get(Unmarshall, _.compact(_.flatten([attr, 'decorate'])));
    decorateFun = decorateFun || _.get(Unmarshall, 'decorate');
    const unmarshalledFilters = _.reduce(filters, (result, v, k) => {
      const applyFun = _.get(Unmarshall, _.compact(_.flatten([attr, k, 'apply'])));
      const marshalledValue = _.isFunction(applyFun) ? applyFun(v) : { [k]: v };
      return decorateFun(_.merge(result, marshalledValue));
    }, {});
    return decorateFun(unmarshalledFilters);
  },
  decorate: (filters) => (filters),
  spot: {
    apply: (filters) => ({ spot: Unmarshall.apply(filters, 'spot') }),
    decorate: (filters) => {
      const res = { ...filters };

      if (filters.date_range) {
        _.merge(res, { date_range: Object.values(filters.date_range) });
      }

      if (filters.accepted_date_range) {
        _.merge(res, { accepted_date_range: Object.values(filters.accepted_date_range) });
      }

      return res;
    },
    start_date: {
      apply: (filters) => ({ date_range: { 0: moment(filters) } }),
    },
    end_date: {
      apply: (filters) => ({ date_range: { 1: moment(filters) } }),
    },
    accepted_start_date: {
      apply: (filters) => ({ accepted_date_range: { 0: moment(filters) } }),
    },
    accepted_end_date: {
      apply: (filters) => ({ accepted_date_range: { 1: moment(filters) } }),
    },
    attributes: {
      apply: unmarshallAttributes,
    },
  },
  user: {
    apply: (filters) => ({ user: Unmarshall.apply(filters, 'user') }),
    attributes: {
      apply: unmarshallAttributes,
    },
  },
  answers: {
    apply: (filters) => ({
      answers: _.flatten(
        filters.map((urlIdFilter) => (
          urlIdFilter.data.map((entry) => (
            { urlId: urlIdFilter.url_id, name: entry.name, value: entry.value }
          ))
        )),
      ),
    }),
  },
};

const flatten = (object, prefix = '') => (Object.keys(object).reduce((prev, element) => {
  const value = object[element];
  return value && _.isObject(value) && !_.isArray(value) && !(value instanceof moment)
    ? { ...prev, ...flatten(object[element], `${prefix}${element}__`) }
    : { ...prev, ...{ [`${prefix}${element}`]: object[element] } };
}, {}));

export const loadFiltersForReport = (reportId) => {
  const filtersFromStorage = localStorage.getItem(`filters_${reportId}`) || '{}';
  return flatten(Unmarshall.apply(JSON.parse(filtersFromStorage)));
};
